import { MEASURE } from './MeasuresConstants';
import { ALL_GRADES, GRADE } from '../shared/GradesConstants';
import { isMeasureAvailableInGrade } from '../../utils/shared/gradeToMeasureUtils';

const {
    KINDERGARTEN,
    PREKINDERGARTEN,
    FIRST_GRADE,
    SECOND_GRADE,
    THIRD_GRADE,
    FOURTH_GRADE,
    FIFTH_GRADE,
    SIXTH_GRADE,
} = GRADE;

const {
    OVERALL,
    LNF,
    PSF,
    NWF_CLS,
    NWF_WRC,
    WRF,
    ORF_ACC,
    ORF,
    TRC,
    OL,
    TRO,
    DO,
    VOCABO,
    SPELLING,
    RAN,
    MAZE,
} = MEASURE;

export const ALL_MEASURES = [
    OVERALL,
    LNF,
    PSF,
    NWF_CLS,
    NWF_WRC,
    WRF,
    ORF_ACC,
    ORF,
    MAZE,
    TRC,
    OL,
    TRO,
    DO,
    VOCABO,
    SPELLING,
    RAN,
];

const getFilteredGrades = gradesToFilter =>
    ALL_GRADES.filter(grade => !gradesToFilter.includes(grade));

const HistoricalMeasuresAvailabilityByGrades = {
    [OVERALL]: ALL_GRADES,
    [LNF]: [PREKINDERGARTEN, KINDERGARTEN, FIRST_GRADE],
    [PSF]: [PREKINDERGARTEN, KINDERGARTEN, FIRST_GRADE],
    [NWF_CLS]: [PREKINDERGARTEN, KINDERGARTEN, FIRST_GRADE, SECOND_GRADE, THIRD_GRADE],
    [NWF_WRC]: [PREKINDERGARTEN, KINDERGARTEN, FIRST_GRADE, SECOND_GRADE, THIRD_GRADE],
    [WRF]: [PREKINDERGARTEN, KINDERGARTEN, FIRST_GRADE, SECOND_GRADE, THIRD_GRADE],
    [ORF_ACC]: getFilteredGrades([PREKINDERGARTEN, KINDERGARTEN]),
    [ORF]: getFilteredGrades([PREKINDERGARTEN, KINDERGARTEN]),
    [MAZE]: getFilteredGrades([PREKINDERGARTEN, KINDERGARTEN, FIRST_GRADE]),
    [TRC]: getFilteredGrades([PREKINDERGARTEN]),
    [OL]: [KINDERGARTEN, FIRST_GRADE, SECOND_GRADE, THIRD_GRADE, FOURTH_GRADE, FIFTH_GRADE],
    [TRO]: [FIRST_GRADE, SECOND_GRADE, THIRD_GRADE, FOURTH_GRADE, FIFTH_GRADE, SIXTH_GRADE],
    [DO]: [FIRST_GRADE, SECOND_GRADE, THIRD_GRADE, FOURTH_GRADE, FIFTH_GRADE, SIXTH_GRADE],
    [VOCABO]: [KINDERGARTEN, FIRST_GRADE, SECOND_GRADE, THIRD_GRADE],
    [SPELLING]: [KINDERGARTEN, FIRST_GRADE, SECOND_GRADE, THIRD_GRADE],
    [RAN]: [KINDERGARTEN, FIRST_GRADE, SECOND_GRADE, THIRD_GRADE],
};

const EXTENDABLE_MEASURES_MAPPER = {
    [LNF]: [SECOND_GRADE],
    [PSF]: [SECOND_GRADE],
};

export const getExtendableMeasuresAvailabilityInGrade = gradeToMeasureMapper =>
    ALL_MEASURES.reduce((acc, measure) => {
        acc[measure] = HistoricalMeasuresAvailabilityByGrades[measure];
        EXTENDABLE_MEASURES_MAPPER[measure]?.forEach(grade => {
            if (isMeasureAvailableInGrade(gradeToMeasureMapper, grade, measure)) {
                acc[measure].push(grade);
            }
        });

        return acc;
    }, {});
